var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g all"},_vm._l((_vm.obj),function(item,index){return _c('mdAll',{key:index,attrs:{"caption":item.caption,"content":item.content}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }